import { DateRangeState } from '@zonofi/zono-money-store';
import moment from 'moment';

export function isValidDateRangeObject(
  obj: DateRangeState
): obj is { key: string; startDate: Date; endDate: Date } {
  const isValidDate = (value: any): value is Date =>
    value instanceof Date && !isNaN(value.getTime());

  return (
    obj &&
    typeof obj.key === 'string' &&
    isValidDate(obj.startDate) &&
    isValidDate(obj.endDate)
  );
}

export function isToday(startDate: Date, endDate: Date): boolean {
  const start = moment(startDate.toISOString()).startOf('day');
  const end = moment(endDate.toISOString()).startOf('day');
  const today = moment().startOf('day');

  return start.isSame(today) && end.isSame(today);
}

export function isThisWeek(startDate: Date, endDate: Date): boolean {
  const start = moment(startDate).startOf('day');
  const end = moment(endDate).startOf('day');
  const weekStart = moment().startOf('week'); // or 'isoWeek' if your week starts on Monday
  const weekEnd = moment().endOf('week');

  return start.isSame(weekStart, 'day') && end.isSame(weekEnd, 'day');
}

export function isYesterday(startDate: Date, endDate: Date): boolean {
  const start = moment(startDate).startOf('day');
  const end = moment(endDate).startOf('day');
  const yesterday = moment().subtract(1, 'day').startOf('day');

  return start.isSame(yesterday) && end.isSame(yesterday);
}
